export const blockIconsHomeVerticalShades = (
	<span className='material-symbols-outlined'>vertical_shades</span>
);
